export default "__VITE_ASSET__BI75PRFe__"